import axios from "axios";
import "aws-sdk/dist/aws-sdk";
import { Auth } from "aws-amplify";

import { config } from "../configs";
import { getSessionToken } from "./getToken";
import { organization } from "../__mocks__";

let __mock__ = false;

const AWS = window.AWS;

const createTopOrg = async (orgData) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/organizations/top`;
      const { data } = await axios({
        method: "POST",
        headers: {
          Authorization: jwtToken,
          // Application: "Platform",
          // Organization: 0,
        },
        url: URL,
        data: orgData,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const createSubOrg = async (orgData, orgId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/organizations/current`;
      const { data } = await axios({
        method: "POST",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url: URL,
        data: orgData,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const places = async (searchTerm) => {
  return new Promise(async function (resolve, reject) {
    try {
      const credentials = await Auth.currentCredentials();

      const client = new AWS.Location({
        credentials,
        region: "us-west-2",
      });
      const data = await client
        .searchPlaceIndexForText({
          IndexName: "plat-place-index",
          Text: searchTerm,
          // FilterCountries: ["USA"],
          MaxResults: 10,
          // BiasPosition: [-123.4567, 45.6789],
        })
        .promise();
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const getUserOrgs = async () => {
  if (__mock__) {
    return [organization];
  }
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/user/organizations`;
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          // Organization: 0,
        },
        url: URL,
      });
      resolve(data);
    } catch (error) {
      // reject(error);
      resolve([]);
    }
  });
};

const getUserOrgsRelated = async (id = undefined) => {
  let orgId = id;
  if (!id) {
    const org = window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION")
      ? JSON.parse(window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION"))
      : undefined;

    orgId = org?.id;
  }
  if (__mock__) {
    return [organization];
  }
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/organizations/related/tree`;
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
          // Organization: 0,
        },
        url: URL,
      });
      resolve(data);
    } catch (error) {
      // reject(error);
      resolve([]);
    }
  });
};

const getOrg = async (id = undefined) => {
  let orgId = id;
  if (!id) {
    const org = window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION")
      ? JSON.parse(window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION"))
      : undefined;
    console.log("org", org);
    orgId = org?.id;
  }
  if (__mock__) {
    return organization;
  }
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/organizations/current`;
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url: URL,
      });

      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const updateOrg = async (orgData, id) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/organizations/current`;
      const { data } = await axios({
        method: "PATCH",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: id,
        },
        url: URL,
        data: orgData,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const getOrgProfileImage = async (orgId, fileType) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/organizations/current/imageurls/get`;
      const response = await axios.get(URL, {
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        params: {
          fileType,
        },
      });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

const updateOrgProfileImage = async (orgId, fileType) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/organizations/current/imageurls/put`;
      const response = await axios.get(URL, {
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        params: {
          fileType,
        },
      });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

const putOrgProfileImage = async (putUrl, file, filetype) => {
  return new Promise(async function (resolve, reject) {
    try {
      const response = await axios.put(putUrl, file, {
        headers: {
          "Content-Type": `image/${filetype}`,
        },
      });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

// Get the users of an organization.
const getOrgUsers = async (orgId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/users`;
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url: URL,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

// Send user invite.
const sendUserInvite = async (attributes, orgId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const url = `${config.baseURL}/organizations/current/inviteuser`;
      const response = await axios({
        method: "PUT",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url,
        data: attributes,
      });
      resolve(response?.status);
    } catch (error) {
      reject(error);
    }
  });
};

export {
  createTopOrg,
  createSubOrg,
  getOrg,
  updateOrg,
  places,
  getUserOrgs,
  getOrgProfileImage,
  updateOrgProfileImage,
  putOrgProfileImage,
  getOrgUsers,
  sendUserInvite,
  getUserOrgsRelated,
};
